import _ from 'lodash'
import { AutoComplete } from 'primereact/autocomplete'
import { InputText } from 'primereact/inputtext'
import { useState } from 'react'

import { FC } from '../../../Services'
import { cap } from '../../../State'
import { translations } from '../../../translations'
import { alert } from '../Functions'

const language = cap.language.state || 'IT'
const t = translations[language]

export const SearchByGroup = ({
  group: [group, setGroup],
  codiceGruppo: [codiceGruppo, setCodiceGruppo],
  descrizioneGruppo: [descrizioneGruppo, setDescrizioneGruppo],
  disabled
}) => {
  const [suggestionsDescrizione, setSuggestionsDescrizione] = useState([])

  const onCodiceChange = async (codiceGruppo) => {
    setGroup()
    setDescrizioneGruppo('')
    setCodiceGruppo(codiceGruppo)
    if (codiceGruppo.length < 2) {
      setDescrizioneGruppo('')
      return
    }
    const group = await FC.service('info').get('getGroups', { query: { codice: codiceGruppo } })
    if (!group.success) {
      alert('error', t.cpErroreRicercaGruppo, group.errorMessage)
      return
    }
    if (!group.found) {
      setDescrizioneGruppo('')
      return
    }
    setDescrizioneGruppo(group.groups[0].descrizione)
  }

  const debounceSearchDescrizione = _.debounce(async (event) => {
    const value = event.query.trim()
    if (value.length < 1) {
      setCodiceGruppo('')
      return setSuggestionsDescrizione([])
    }
    const group = await FC.service('info').get('getGroups', { query: { descrizione: value } })
    const descrizioni = group.groups.map((el) => el.descrizione)
    setSuggestionsDescrizione(descrizioni)
    if (descrizioni.length !== 1) {
      setCodiceGruppo('')
      return
    }
    setCodiceGruppo(group.groups[0].codice)
  }, 500)

  const selectDescrizioneGruppo = async (value) => {
    const group = await FC.service('info').get('getGroups', { query: { descrizione: value } })
    setCodiceGruppo(group.groups[0].codice)
  }

  const onDescrizioneChange = async (value) => {
    setGroup()
    setCodiceGruppo('')
    setDescrizioneGruppo(value)
  }

  return (
    <div className="community-search-panel__block">
      <div className="nfield" style={{ marginBottom: 12 }}>
        <label style={{ fontSize: 13, fontWeight: 600 }}>{t.ricercaGruppo}</label>
      </div>
      <div className="nfield" style={{ marginBottom: 12 }}>
        <label>{t.codiceGruppo}</label>
        <InputText
          value={codiceGruppo || ''}
          style={{ width: '100%', borderRadius: 8 }}
          maxLength={3}
          onChange={(e) => onCodiceChange(e.target.value)}
          id="codiceGruppo"
          placeholder={t.codice}
          disabled={disabled}
        />
      </div>
      <div className="nfield">
        <label>{t.descrizione}</label>
        <AutoComplete
          disabled={disabled}
          inputId="descrizioneGruppo"
          placeholder={t.descrizione}
          inputStyle={{ width: '100%', borderRadius: 8 }}
          style={{ width: '100%' }}
          value={descrizioneGruppo || ''}
          suggestions={suggestionsDescrizione}
          completeMethod={debounceSearchDescrizione}
          onChange={(e) => onDescrizioneChange(e.target.value)}
          onSelect={({ value }) => selectDescrizioneGruppo(value)}
        />
      </div>
    </div>
  )
}
